<div class="details-item" [ngClass]="{ small: isSmall(), inline: isInLine() }">
  @if (header()) {
    <h4 class="details-item__header">
      {{ header() }}
      @if (tooltip()) {
        <mat-icon [matTooltip]="tooltip()">help</mat-icon>
      }
      {{ isInLine() ? ':' : '' }}
    </h4>
  }
  <div class="details-item__value">
    <ng-content></ng-content>
  </div>
  @if (!header() && tooltip()) {
    <mat-icon [matTooltip]="tooltip()">help</mat-icon>
  }
</div>
